export default __webpack_public_path__ + "static/media/Statistic-2014-2015_SUB.4f9bc518.pdf";